import { library as library1 } from "@fortawesome/fontawesome-svg-core";
import {
  faFacebookF,
  faFacebook,
  faTwitter,
  faLinkedin,
  faLinkedinIn,
  faInstagram,
  faFontAwesome,
  faBehance,
  faPinterestP,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";

library1.add(
  faFacebookF,
  faTwitter,
  faLinkedin,
  faLinkedinIn,
  faInstagram,
  faFontAwesome,
  faBehance,
  faFacebook,
  faPinterestP,
  faWhatsapp
);
